export default function computeClasses(classes: { [key: string]: boolean }): string {
    return Object.keys(classes).reduce((accum, key) => {
        if (!classes[key]) return accum;

        return `${accum} ${key}`;
    }, '');
}